// extracted by mini-css-extract-plugin
module.exports = {"EducationWrapper":"education_EducationWrapper__2GzJc","Educated":"education_Educated__2TqD4"};